type TProps = {
    className?: string;
}

export const Panel: React.FC<TProps> = ({ children, className }) => (
    <div className={`bg-white rounded-xl shadow p-4 ${className}`}>
        {children}
    </div>
);